import {Component, Input} from '@angular/core';
import {ReferenceBookResponse} from '@npck/af-frontend-api';

@Component({
    selector: 'af-classification-panel',
    standalone: false,
    templateUrl: './classification-panel.component.html',
    styleUrl: './classification-panel.component.scss',
})
export class ClassificationPanelComponent {
    @Input() item: ClassificationPanelViewModel;

}

export interface ClassificationPanelViewModel {
    dictionaryItem: ReferenceBookResponse,
    count: number;
}
